/**
 * Logging utility that respects environment configuration.
 * Debug logs are only shown in development mode.
 * 
 * Usage:
 *   import { logger } from '@/utils/logger';
 *   logger.debug('Debug message');  // Only in development
 *   logger.info('Info message');    // Always logs
 *   logger.warn('Warning');         // Always logs
 *   logger.error('Error');          // Always logs
 */

export const logger = {
  /**
   * Debug logging - only shown in development environment
   * Use for detailed debugging information that shouldn't appear in production
   */
  debug: (...args) => {
    // Check environment dynamically for better testability
    const isDevelopment = import.meta.env.MODE === 'development';
    if (isDevelopment) {
      console.log(...args);
    }
  },
  
  /**
   * Info logging - always shown
   * Use for important informational messages
   */
  info: (...args) => {
    console.info(...args);
  },
  
  /**
   * Warning logging - always shown
   * Use for warning messages that need attention
   */
  warn: (...args) => {
    console.warn(...args);
  },
  
  /**
   * Error logging - always shown
   * Use for error messages that need immediate attention
   */
  error: (...args) => {
    console.error(...args);
  }
};
